import React from 'react'
import { animated } from 'react-spring'

export const AnimatedSpan = (props) => (<animated.span {...props} />)
export const AnimatedNav = (props) => (<animated.nav {...props} />)
export const AnimatedFigure = (props) => (<animated.figure {...props} />)
